import Link from 'next/link';
import { User, BarChart2, Unlock, ArrowRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'next-i18next';
export default function HowItWorks() {
  const { t } = useTranslation('common');
  const steps = [
    {
      icon: <User className="w-16 h-16 text-pink-500 mb-6" />,
      title: t('Enter Username'),
      titleKey: 'Step 1: Enter Your Instagram Username',
      description: t(
        'Enter your Instagram username to start using Dolphin Radar’s best unfollowers tracker. No downloads or installations required!'
      ),
    },
    {
      icon: <BarChart2 className="w-16 h-16 text-pink-500 mb-6" />,
      title: t('We Analyze, Get Truth'),
      titleKey: 'Step 2: Analyze Your Followers and Non-Followers',
      description: t(
        'Dolphin Radar analyzes your Instagram data to show you who unfollowed you, along with users who don’t follow back.'
      ),
    },
    {
      icon: <Unlock className="w-16 h-16 text-pink-500 mb-6" />,
      title: t('Satisfied? Learn More'),
      titleKey: 'Step 3: Take Action to Manage Your Account',
      description: t(
        'View detailed reports on unfollowers and take action to manage your Instagram followers effectively.'
      ),
    },
  ];

  return (
    <div id="how-it-works" className="py-20 ">
      <div className="container mx-auto px-4">
        <h2 className="hidden">{t('Key Features')}</h2>
        <h3 className="hidden">{t('No IG Login Needed')}</h3>
        <h3 className="hidden">{t('Anonymous & Legal')}</h3>
        <h3 className="hidden">{t('Exportable Results Table')}</h3>
        <h3 className="hidden">{t('Reliable & Accurate Data')}</h3>
        <h3 className="hidden">{t('50,000+ Users Trust Dolphin Radar')}</h3>
        <div className="text-3xl font-bold text-center mb-16">
          {t('How Does Dolphin Radar’s Unfollowers Tracker Work?')}
        </div>
        <div className="flex flex-col md:flex-row justify-between items-start max-w-4xl mx-auto space-y-12 md:space-y-0">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="flex flex-col items-center text-center w-full md:w-1/3 relative h-full">
                {step.icon}
                <div className="h-32 flex flex-col justify-between">
                  <div className="text-xl font-semibold mb-3">
                    {index === 2 ? (
                      <>
                        {t('Satisfied?')}{' '}
                        <Link href="/instagram-unfollowers-tracker#1" className="text-blue-500 hover:underline">
                          {t('Learn More')}
                        </Link>
                      </>
                    ) : (
                      step.title
                    )}
                  </div>
                  <p className="text-gray-600 max-w-xs">{step.description}</p>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block text-pink-500 w-8 h-8 mx-4 pt-5">
                  <ArrowRight className="text-pink-500 w-8 h-8 " />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
